import { favoriteStyle, unfavoriteStyle } from '../../../core/js/actions/favoritesActions';

import { dDom } from '../../../core/js/utils/renderUtils';
import template from 'product-favorited.j2';

import { generate } from '../../../core/js/utils/componentUtils';
import { onStateChange } from '../utils/productComponentUtils';

/**
 * Attach component events to DOM
 * @param {object} store The store
 */
function attachEvents(store) {
    // toggle favorite click
    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-favorite-toggle'), (event) => {
        event.preventDefault();

        const state = store.getState();
        const product = this.getTargetedProduct(state);
        const productDisplayName = _.get(product, 'product.displayName');
        const styleNumber = _.get(product, 'styleNumber');

        if (product.favorited) {
            // remove favorite
            store.dispatch(unfavoriteStyle(styleNumber, productDisplayName, this));
        } else {
            store.dispatch(favoriteStyle(styleNumber, productDisplayName, this));
        }
    });
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-product-image-viewer-wrapper .dom-favorited',
        attachEvents: attachEvents,
        watch: 'product.favorited',
        template: template,
        onStateChange: onStateChange,
        name: 'productFavoritesComponent',
        renderType: dDom,
        afterRebind: onStateChange
    };

    return generate(config, store, overrides);
}
